// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------search--------------------*/

.l0d0rE3KAOk8_bwcLIzT {
    border-radius: 20px;
    border: 0px;
    background: rgba(var(--tertiary-bg-dark), 0.3);
    color: rgb(var(--placeholder-primary-dark));
    padding: 16px 45px 16px 50px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
    letter-spacing: -0.5px;
  }
  
  .VG7wPBarPl7AV3ebghzJ {
    position: relative;
    margin-bottom: 8px;
  }
  
  .XK4isl1PwDCwwzU6dDXe {
    position: absolute;
    left: 17px;
    top: 50%;
    width: 24px;
    height: 24px;
    transform: translateY(-50%);
    > path {
      stroke: #98989E;
    }
  }
  
  .XqJO6mWCPodr1upfsPeC {
    position: absolute;
    right: 20px;
    top: 52%;
    width: 20px;
    height: 20px;
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /*--------------------/search--------------------*/
  
  .Bn3s4L0EqrRl_mutBm3u {
    font-size: 15px;
    line-height: 138%;
    letter-spacing: 0.07px;
    color: #8E8E93;
  }
  
  .cL7vaBrFb6WkC33U4bx3 {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    outline: none;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  .cL7vaBrFb6WkC33U4bx3 > div {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /*--------------------token--------------------*/

  .nat2reuqhGwNdaxmCiUe {
    height: calc(100% - 80px);
    padding: 16px;
    background: rgba(var(--secondary-bg), 0.40);
    border-radius: 24px 24px 0 0;
  }
  
  .GqVZQI6qx0GSBobU5luz {
    max-height: 100%;
    overflow-y: auto;
    padding-bottom: 72px;
  }
    
  .VRoQZnlUW2PRSVglhKhQ {
    padding: 10px 10px 8px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    position: relative;
    width: 100%;
    cursor: pointer;
    border-radius: 24px;
    margin-bottom: 4px;
  }

  .VRoQZnlUW2PRSVglhKhQ:active {
    background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .tokenItem:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

  
  .VRoQZnlUW2PRSVglhKhQ::before {
    content: '';
    position: absolute;
    width: calc(100% - 51.1px);
    height: 0.1px;
    bottom: -2px;
    right: 0;
    background: rgba(116, 116, 128, 0.4);
  }
  
  .T2HvZaebsy3ZsuximaAV {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    width: 100%;
  }

  .Ycov5k1DE77ZDsvR91e5 {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 5px;
  }
  .M1jAmHkULD6HpSwdaIKz {
    color: #34C759 !important;
  }
  .TjZxUvbZGUENHgJxHWU0 {
    color: #FF3B30 !important;
  }

  .xRL2LEHG7xDbcWGyH4sZ {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: calc(100% - 60px);
  }
  
  .bXSLwEfBDc6Z8DaEmxZg {
    display: flex;
    flex-direction: column;
  }

  .T2HvZaebsy3ZsuximaAV > img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  
  .nLfnuFaL_SyiRLMtW4BG {
    font-size: 17px;
    line-height: 129%;
    letter-spacing: 0.43px;
    color: rgb(var(--placeholder-primary));
  }

  .iookr8Tt8FCVERizROwJ {
    color: rgb(var(--placeholder-primary));
    text-align: right;
  }

  .iKbHSKoReJtQBwKwwUKl {
    color: rgb(var(--placeholder-secondary));
    font-size: 13px;
    line-height: 19.5px;
  }
  .FRxRqM0ByQM3jZXxwM7m {
    color: #8E8E93;
    font-size: 11px;
    line-height: 19.5px;
  }
  
  /*--------------------/token--------------------*/
  
  .WYwzVKBqmzClyqo0YSh4 {
    height: 30vh;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -20px;
    text-align: center;
    font-size: 21px;
    font-weight: 540;
  }

/* ------------- */
.QJh7aUmFB9WCAlYCSgw7 {
  display: grid;
  grid-template-columns: 0.5fr 2fr 0.5fr;
  align-items: center;
  gap: 5px;
  margin-bottom: 24px;
}

.jqu5k_mAYGzIt8av2vDK {
  color: rgb(var(--accent-brand));
  font-size: 16.5px;
  font-weight: 540;
  letter-spacing: 0.43px;
  background: transparent;
  cursor: pointer;
  border: none;
  z-index: 305;
  padding: 4px;
  border-radius: 8px;
  transition: all 0.3s ease 0s;
}

.jqu5k_mAYGzIt8av2vDK > svg {
  cursor: pointer;
  > path {
    stroke: rgb(var(--accent-brand));
  }
}

.jqu5k_mAYGzIt8av2vDK > svg:hover {
  color: rgba(var(--accent-brand), 0.8);
}

.jqu5k_mAYGzIt8av2vDK:first-child {
  justify-content: flex-start;
}

.jqu5k_mAYGzIt8av2vDK:active {
  background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .modalTopButton:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.PTenk9jMaMRHGPYNiW1U {
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 510;
  line-height: 32px; /* 100% */
  letter-spacing: -0.264px;
  color: rgb(var(--placeholder-primary-dark));
  margin-bottom: 24px;
}

.rG0AqLV6nJJ6ykpi8SjO {
  position: relative;
  z-index: 301;
  overflow-x: hidden;
}

.U1YPZze1Ql9tFJZqW1YZ {
  height: 95%;
  overflow-y: hidden;
  background: rgb(var(--primary-bg));
  z-index: 301;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/pages/swap/selectAsset/select-asset.module.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;IACI,mBAAmB;IACnB,WAAW;IACX,8CAA8C;IAC9C,2CAA2C;IAC3C,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B;MACE,eAAe;IACjB;EACF;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,eAAe;EACjB;;EAEA,kDAAkD;;EAElD;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,gDAAgD;;EAEhD;IACE,yBAAyB;IACzB,aAAa;IACb,2CAA2C;IAC3C,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kDAAkD;AACtD;;AAEA;;GAEG;;;EAGD;IACE,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,QAAQ;IACR,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;EACV;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;IACtC,iBAAiB;EACnB;;EAEA;IACE,wCAAwC;IACxC,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA,iDAAiD;;EAEjD;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;AAEF,kBAAkB;AAClB;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,wBAAwB;EACxB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/*--------------------search--------------------*/\n\n.search {\n    border-radius: 20px;\n    border: 0px;\n    background: rgba(var(--tertiary-bg-dark), 0.3);\n    color: rgb(var(--placeholder-primary-dark));\n    padding: 16px 45px 16px 50px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 125% */\n    letter-spacing: -0.5px;\n  }\n  \n  .searchInner {\n    position: relative;\n    margin-bottom: 8px;\n  }\n  \n  .searchIcon {\n    position: absolute;\n    left: 17px;\n    top: 50%;\n    width: 24px;\n    height: 24px;\n    transform: translateY(-50%);\n    > path {\n      stroke: #98989E;\n    }\n  }\n  \n  .scan {\n    position: absolute;\n    right: 20px;\n    top: 52%;\n    width: 20px;\n    height: 20px;\n    transform: translateY(-50%);\n    cursor: pointer;\n  }\n  \n  /*--------------------/search--------------------*/\n  \n  .assetsTitle {\n    font-size: 15px;\n    line-height: 138%;\n    letter-spacing: 0.07px;\n    color: #8E8E93;\n  }\n  \n  .searchClear {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    outline: none;\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    right: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n  }\n  \n  .searchClear > div {\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  /*--------------------token--------------------*/\n\n  .seleсtWrapper {\n    height: calc(100% - 80px);\n    padding: 16px;\n    background: rgba(var(--secondary-bg), 0.40);\n    border-radius: 24px 24px 0 0;\n  }\n  \n  .tokensList {\n    max-height: 100%;\n    overflow-y: auto;\n    padding-bottom: 72px;\n  }\n    \n  .tokenItem {\n    padding: 10px 10px 8px 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    position: relative;\n    width: 100%;\n    cursor: pointer;\n    border-radius: 24px;\n    margin-bottom: 4px;\n  }\n\n  .tokenItem:active {\n    background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .tokenItem:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n  \n  .tokenItem::before {\n    content: '';\n    position: absolute;\n    width: calc(100% - 51.1px);\n    height: 0.1px;\n    bottom: -2px;\n    right: 0;\n    background: rgba(116, 116, 128, 0.4);\n  }\n  \n  .tokenItemBody {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n  }\n\n  .usdPriseWrapper {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    gap: 5px;\n  }\n  .upChange {\n    color: #34C759 !important;\n  }\n  .downChange {\n    color: #FF3B30 !important;\n  }\n\n  .tokenItemInner {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: calc(100% - 60px);\n  }\n  \n  .tokenColumn {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .tokenItemBody > img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n  }\n  \n  .tokenItemToken {\n    font-size: 17px;\n    line-height: 129%;\n    letter-spacing: 0.43px;\n    color: rgb(var(--placeholder-primary));\n  }\n\n  .tokenItemAmountRight {\n    color: rgb(var(--placeholder-primary));\n    text-align: right;\n  }\n\n  .tokenItemPrice {\n    color: rgb(var(--placeholder-secondary));\n    font-size: 13px;\n    line-height: 19.5px;\n  }\n  .tokenItemPriceChange {\n    color: #8E8E93;\n    font-size: 11px;\n    line-height: 19.5px;\n  }\n  \n  /*--------------------/token--------------------*/\n  \n  .noAssets {\n    height: 30vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: -20px;\n    text-align: center;\n    font-size: 21px;\n    font-weight: 540;\n  }\n\n/* ------------- */\n.modalTop {\n  display: grid;\n  grid-template-columns: 0.5fr 2fr 0.5fr;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 24px;\n}\n\n.modalTopButton {\n  color: rgb(var(--accent-brand));\n  font-size: 16.5px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  z-index: 305;\n  padding: 4px;\n  border-radius: 8px;\n  transition: all 0.3s ease 0s;\n}\n\n.modalTopButton > svg {\n  cursor: pointer;\n  > path {\n    stroke: rgb(var(--accent-brand));\n  }\n}\n\n.modalTopButton > svg:hover {\n  color: rgba(var(--accent-brand), 0.8);\n}\n\n.modalTopButton:first-child {\n  justify-content: flex-start;\n}\n\n.modalTopButton:active {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .modalTopButton:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.modalTitle {\n  text-align: center;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 510;\n  line-height: 32px; /* 100% */\n  letter-spacing: -0.264px;\n  color: rgb(var(--placeholder-primary-dark));\n  margin-bottom: 24px;\n}\n\n.wrapper {\n  position: relative;\n  z-index: 301;\n  overflow-x: hidden;\n}\n\n.modal {\n  height: 95%;\n  overflow-y: hidden;\n  background: rgb(var(--primary-bg));\n  z-index: 301;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `l0d0rE3KAOk8_bwcLIzT`,
	"searchInner": `VG7wPBarPl7AV3ebghzJ`,
	"searchIcon": `XK4isl1PwDCwwzU6dDXe`,
	"scan": `XqJO6mWCPodr1upfsPeC`,
	"assetsTitle": `Bn3s4L0EqrRl_mutBm3u`,
	"searchClear": `cL7vaBrFb6WkC33U4bx3`,
	"seleсtWrapper": `nat2reuqhGwNdaxmCiUe`,
	"tokensList": `GqVZQI6qx0GSBobU5luz`,
	"tokenItem": `VRoQZnlUW2PRSVglhKhQ`,
	"tokenItemBody": `T2HvZaebsy3ZsuximaAV`,
	"usdPriseWrapper": `Ycov5k1DE77ZDsvR91e5`,
	"upChange": `M1jAmHkULD6HpSwdaIKz`,
	"downChange": `TjZxUvbZGUENHgJxHWU0`,
	"tokenItemInner": `xRL2LEHG7xDbcWGyH4sZ`,
	"tokenColumn": `bXSLwEfBDc6Z8DaEmxZg`,
	"tokenItemToken": `nLfnuFaL_SyiRLMtW4BG`,
	"tokenItemAmountRight": `iookr8Tt8FCVERizROwJ`,
	"tokenItemPrice": `iKbHSKoReJtQBwKwwUKl`,
	"tokenItemPriceChange": `FRxRqM0ByQM3jZXxwM7m`,
	"noAssets": `WYwzVKBqmzClyqo0YSh4`,
	"modalTop": `QJh7aUmFB9WCAlYCSgw7`,
	"modalTopButton": `jqu5k_mAYGzIt8av2vDK`,
	"modalTitle": `PTenk9jMaMRHGPYNiW1U`,
	"wrapper": `rG0AqLV6nJJ6ykpi8SjO`,
	"modal": `U1YPZze1Ql9tFJZqW1YZ`
};
export default ___CSS_LOADER_EXPORT___;
